
  import {defineComponent, computed, PropType, Ref} from "vue";
  import {CompanyLocationV2Dto} from "@/service/CompanyLocationService";

  export default defineComponent({
    name: "InventoriesCompanyLocationsGeneralForm",
    props: {
      companyLocation: {
        required: true,
        type: Object as PropType<CompanyLocationV2Dto>
      },
      errors: {
        required: false,
        type: Map as PropType<Map<string, string | Ref<string>>>,
        default: () => new Map<string, string>()
      }
    },
    setup(props, context) {

      const companyLocationInputModel = computed({
        get(): CompanyLocationV2Dto {
          return props.companyLocation;
        },
        set(newValue: CompanyLocationV2Dto) {
          context.emit("companyLocationChanged", newValue);
        },
      });

      return {
        companyLocationInputModel
      };
    }
  });
